import axios from '../axios';

import type { Track } from '../interfaces/track';
import type { Artist } from '../interfaces/artist';
import type { Pagination, PaginationQueryParams } from '../interfaces/api';
import { Episode } from '../interfaces/episode';
import { User } from '../interfaces/user';
import { PlaylistItem } from '../interfaces/playlists';

const stubBooleans = (ids: string[]) => Promise.resolve({ data: ids.map(() => false) });
const stubBoolean = () => Promise.resolve({ data: false });
const stubOk = () => Promise.resolve({ data: 'OK' });
const stubEmptyPaging = <T>() => Promise.resolve({ data: { items: [], limit: 50, offset: 0, total: 0, previous: null, next: null, href: '' } as unknown as Pagination<T> });

const fetchTopTracks = (params: any) => stubEmptyPaging<Track>();
const fetchTopArtists = (params: any) => stubEmptyPaging<Artist>();
const fetchFollowedArtists = (params: any) => Promise.resolve({ data: { artists: { items: [], limit: 50, offset: 0, total: 0, previous: null, next: null, href: '' } as unknown as Pagination<Artist> } });
const fetchQueue = () => Promise.resolve({ data: { currently_playing: null as unknown as Track, queue: [] } });
const checkSavedTracks = (ids: string[]) => stubBooleans(ids);
const saveTracks = (ids: string[]) => stubOk();
const deleteTracks = (ids: string[]) => stubOk();
const checkFollowedPlaylist = (id: string) => Promise.resolve({ data: [false] });
const checkFollowingArtists = (ids: string[]) => stubBooleans(ids);
const checkFollowingUsers = (ids: string[]) => stubBooleans(ids);
const getUser = (id: string) => Promise.resolve({ data: null as unknown as User });
const unfollowPlaylist = (id: string) => stubOk();
const followPlaylist = (id: string) => stubOk();
const followArtists = (ids: string[]) => stubOk();
const unfollowArtists = (ids: string[]) => stubOk();
const followUsers = (ids: string[]) => stubOk();
const unfollowUsers = (ids: string[]) => stubOk();
const getSavedTracks = (params: any) => stubEmptyPaging<PlaylistItem>();

export const userService = {
  getUser,
  saveTracks,
  fetchQueue,
  deleteTracks,
  getSavedTracks,
  fetchTopArtists,
  fetchTopTracks,
  checkSavedTracks,
  followPlaylist,
  checkFollowingUsers,
  followUsers,
  unfollowUsers,
  fetchFollowedArtists,
  checkFollowedPlaylist,
  unfollowPlaylist,
  checkFollowingArtists,
  followArtists,
  unfollowArtists,
};
